// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.embla-dots-box {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  margin: 1rem auto;
}
.embla-dots-box .embla__dot {
  width: 1.25rem;
  min-width: 1.25rem;
  height: 1.25rem;
  background-color: transparent;
  border: 2px solid var(--black-1000);
  border-radius: 50%;
  cursor: pointer;
  transition: 200ms all ease-in-out;
}
.embla-dots-box .embla__dot:hover {
  background-color: var(--black-250);
}
.embla-dots-box .embla__dot--selected {
  background-color: var(--black-1000);
  transition: 200ms all ease-in-out;
}
@media screen and (max-width: 991.98px) {
  .embla-dots-box .embla__dot {
    width: 1rem;
    min-width: 1rem;
    height: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .embla-dots-box {
    gap: 0.25rem;
  }
  .embla-dots-box .embla__dot {
    width: 0.625rem;
    min-width: 0.625rem;
    height: 0.625rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/EmblaDotButton/EmblaDotButtonStyle.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AADF;AAGE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AADJ;AAGI;EACE,kCAAA;AADN;AAKE;EACE,mCAAA;EACA,iCAAA;AAHJ;AAME;EACE;IACE,WAAA;IACA,eAAA;IACA,YAAA;EAJJ;AACF;AAOE;EApCF;IAqCI,YAAA;EAJF;EAME;IACE,eAAA;IACA,mBAAA;IACA,gBAAA;EAJJ;AACF","sourcesContent":["\n\n.embla-dots-box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0 0.5rem;\n  margin: 1rem auto;\n\n  .embla__dot {\n    width: 1.25rem;\n    min-width: 1.25rem;\n    height: 1.25rem;\n    background-color: transparent;\n    border: 2px solid var(--black-1000);\n    border-radius: 50%;\n    cursor: pointer;\n    transition: 200ms all ease-in-out;\n\n    &:hover {\n      background-color: var(--black-250);\n    }\n  }\n  \n  .embla__dot--selected {\n    background-color: var(--black-1000);\n    transition: 200ms all ease-in-out;\n  }\n\n  @media screen and (max-width: 991.98px) {\n    .embla__dot {\n      width: 1rem;\n      min-width: 1rem;\n      height: 1rem;\n    }\n  }\n  \n  @media screen and (max-width: 767.98px) {\n    gap: 0.25rem;\n    \n    .embla__dot {\n      width: 0.625rem;\n      min-width: 0.625rem;\n      height: 0.625rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
